export default function assembleFetchParams() {
  const url = window.location.href;
  const formattedUrl = url.replace(/\?.*/g, `?${encodeURIComponent(url.split('?')[1])}`);
  const ajaxUrl = window.ajaxurl;
  const action = 'action=kff_get_shortlink';
  const dest = `destination=${formattedUrl}`;
  const nonce = window.kff_shortlink.ajax_security;
  const security = `ajax_security=${nonce}`;
  const title = 'title=Custom State Report - Kaiser Family Foundation';
  const desc = 'description=A custom state report from the Kaiser Family Foundation.';

  return {
    ajaxUrl,
    action,
    dest,
    security,
    title,
    desc,
  };
}



// WEBPACK FOOTER //
// ./app/services/assembleFetchParams.js